/* eslint-disable */
import * as types from './mutation-types';

export default {
  /**
  * Login
  */
  [types.SET_LIST_PRODUCT](state, { list }) {
    state.listProducts = list;
  },
};
